import {Component, OnInit} from "@angular/core";
import {New} from "../new";
import {NewService} from "../new.service";
import {Router} from "@angular/router";
@Component({
  template:`    
    <div class="big-about">
       
        <div class="middle-box"><br>
        <h2>最新消息</h2><br>
        <div class="line-about"></div><br>
        <p>關於本店近況及商品的最新消息皆會在此不定期發佈！！！
        </p>
        </div></div>
        <div class="container2">
        <div class="title-clothes">
        2025/07/08 - "STIGA" 2025新款神仙球鞋到貨～📢📢

        </div>

        <p class="news_content_wrap">
        STIGA 2025新款神仙球鞋到貨～
        🏆來自北歐の硬核基因
        世界冠軍都是用STIGA的拍子奪冠的哦🏆這款乒乓球鞋，作為他們運動系列的新寵兒，延續了品牌一貫的專業。採用高彈中底+防滑橡膠+透氣網面三重組合，簡直就是為高強度對抗量身打造的「球場戰靴」，男女通用的設計款。
        👟功能亮點大公開
        這雙鞋真的不是「看起來好看而已」那種花瓶選手。它的緩震系統，雖然是乒乓球鞋，但踩下去那一下真的有種“踩雲感”，跑動時膝蓋壓力明顯減小了不少，對膝蓋不太好的人超級友好👏 其次是透氣性，夏天打球最容易出汗，而這雙鞋的鞋面是高密度透氣網布材質，穿著一整天都不會悶腳，腳氣星人感動落淚😭還有就是鞋底紋路設計非常科學，抓地力強到離譜，急停轉身完全不會打滑，急安全感滿滿💯
        不只是球鞋--穿搭私藏百搭
        搭配運動褲、短褲、短裙、牛仔褲統合OK，尤其是配上運動風衛衣，瞬間變身韓系風格
        </p> 

        <div class="detailimg">
        <img src="../../../img/detail5/img1.jpg" height="500px" class="detailautoimg">
        <img src="../../../img/detail5/img2.jpg" height="500px" class="detailautoimg">
        </div>
      

        
       <button class="sharebutton" (click)="Facebook()"><img src="../../../img/fb-live-map_2.png" width="60px"></button>
       <button class="sharebutton" (click)="Google()"><img src="../../../img/photo.jpg" width="50px"></button>
       <button class="sharebutton" (click)="Twitter()"><img src="../../../img/Twitter.png" width="50px"></button>
      
       </div>
       
       
       
       <div class="new_button" style="text-align: center;margin-bottom: 30px;width:150px;margin:auto;margin-bottom:30px;">
       <button style="color: white;background-color: #CC3366;border: none;" (click)="gotoHome()">回到首頁</button></div>
    `,
  styles: [`    
    .cool button{
    float: left;
    background-color: white;
    margin-left: 30px;
    border: none;
    
    }
    
    .cool{
    width:700px;
    font-size: 18px;
    font-weight: bold;
    }
    
   
    .container{
    margin-bottom: 30px;
    }
    
    `],
  inputs:['ptitle','pcontent']

})

export class Detail5Component implements OnInit{
  public ptitle:string;
  public pcontent:string;
  constructor(private newservice:NewService,private router:Router){}
  ngOnInit(){
    this.ptitle=this.newservice.getTitle()
    
    this.pcontent=this.newservice.getContent()
  }
  gotoHome(){
    this.router.navigate(['/']);
  }
  Facebook() {
    void(window.open('http://www.facebook.com/share.php?u='.concat(encodeURIComponent(location.href)) ));
  }
  Google(){
    void(window.open('https://lineit.line.me/share/ui?url='.concat(encodeURIComponent(location.href)) ));
  }

  Twitter(){
    void(window.open('http://twitter.com/home/?status='.concat(encodeURIComponent(location.href))));
  }


}



// WEBPACK FOOTER //
// ./src/app/news/detail/detail5.component.ts